import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpIcon, ArrowDownIcon, BoxIcon } from 'lucide-react';
interface StatsCardProps {
  title: string;
  value: string | number;
  trend?: number;
  trendLabel?: string;
  icon: BoxIcon;
  color?: 'gold' | 'blue' | 'green' | 'purple';
  delay?: number;
}
export function StatsCard({
  title,
  value,
  trend,
  trendLabel = 'vs last month',
  icon: Icon,
  color = 'gold',
  delay = 0
}: StatsCardProps) {
  const getColorClass = () => {
    switch (color) {
      case 'gold':
        return 'bg-famo-gold/10 text-famo-gold';
      case 'blue':
        return 'bg-blue-100 text-blue-600';
      case 'green':
        return 'bg-green-100 text-green-600';
      case 'purple':
        return 'bg-purple-100 text-purple-600';
      default:
        return 'bg-famo-gold/10 text-famo-gold';
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay
  }} className="bg-white rounded-xl p-6 shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-88">
      <div className="flex justify-between items-start mb-4" data-id="element-89">
        <div data-id="element-90">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-91">{title}</p>
          <h3 className="text-2xl font-bold text-slate-900" data-id="element-92">{value}</h3>
        </div>
        <div className={`p-3 rounded-lg ${getColorClass()}`} data-id="element-93">
          <Icon size={20} data-id="element-94" />
        </div>
      </div>

      {trend !== undefined && <div className="flex items-center text-xs" data-id="element-95">
          <span className={`flex items-center font-medium ${trend >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-96">
            {trend >= 0 ? <ArrowUpIcon size={14} className="mr-1" data-id="element-97" /> : <ArrowDownIcon size={14} className="mr-1" data-id="element-98" />}
            {Math.abs(trend)}%
          </span>
          <span className="text-slate-400 ml-2" data-id="element-99">{trendLabel}</span>
        </div>}
    </motion.div>;
}